<template>
    <div>
        <v-title-guide :step="0" style="margin-top: 30px;"/>
        <v-app>
            <div class="container">
                <div class="sample-title">프리미엄 리포트 예시</div>
                <div class="desc">셀비 체크업 앱을 설치하고 보다 자세하고 정확한 분석 결과를 받아 보세요.</div>
                <div class="btn" @click="launchApp()">셀비 체크업 앱 열기 ></div>

                <div class="sample-container">
                    <v-carousel
                        cycle
                        interval="2000"
                        hide-delimiters
                        :show-arrows="true"
                    >
                        <v-carousel-item
                            v-for="(report, index) in sampleReport"
                            :key="index"
                        >
                            <img :src="report" class="sample">
                        </v-carousel-item>
                    </v-carousel>
                </div>
            </div>
        </v-app>
    </div>
</template>

<script>
    import VTitleGuide from '@/components/titleGuide'

    export default {
        components: {
            VTitleGuide
        },
        data () {
            return {
                sampleReport: [
                    require('@/assets/images/report-sample-01@3x.png'),
                    require('@/assets/images/report-sample-02@3x.png'),
                    require('@/assets/images/report-sample-03@3x.png'),
                    require('@/assets/images/report-sample-04@3x.png'),
                    require('@/assets/images/report-sample-05@3x.png'),
                    require('@/assets/images/report-sample-06@3x.png'),
                    require('@/assets/images/report-sample-07@3x.png'),
                    require('@/assets/images/report-sample-08@3x.png'),
                    require('@/assets/images/report-sample-09@3x.png'),
                    require('@/assets/images/report-sample-10@3x.png'),
                    require('@/assets/images/report-sample-11@3x.png'),
                    require('@/assets/images/report-sample-12@3x.png'),
                    require('@/assets/images/report-sample-13@3x.png'),
                    require('@/assets/images/report-sample-14@3x.png'),
                    require('@/assets/images/report-sample-15@3x.png'),
                    require('@/assets/images/report-sample-16@3x.png'),
                    require('@/assets/images/report-sample-17@3x.png')
                ]
            }
        },
        mounted () {
            window.scrollTo(0, 0)
        },
        methods: {
            launchApp() {
                /*
                const siteCode = sessionStorage.getItem('siteCode') || 'normal'
                if (siteCode === 'orangeLife') {
                    if (process.env.NODE_ENV === 'development') {
                        return window.open(`http://manager-dev.selvy.ai/f/${siteCode}`)
                    }
                    return window.open(`https://manager.selvy.ai/f/${siteCode}`)
                }
                */
                return window.open('https://links.selvy.ai/app')
            }
	    }
    }
</script>

<style scoped>
    .container {
        font-family: "SpoqaHanSans";
        text-align: center;
        padding: 0px 30px 5vw 30px;
    }
    .sample-title {
        font-weight: bold;
        font-size: 14px;
        color: #202020;
        margin-bottom: 6px;
    }
    .desc {
        font-size: 14px;
        color: #202020;
        margin-bottom: 41px;
        word-break: keep-all;
    }
    .btn {
        height: 44px;
        width: 100%;
        line-height: 44px;
        border-radius: 22px;
        box-shadow: 0 8px 20px -4px rgba(63, 111, 255, 0.5);
        vertical-align: middle;
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 30px;
        background-color: #3f6fff;
        color: white;
    }
    .sample-container {
        text-align: center;
    }
    .sample {
        text-align: center;
        width: 100%;
    }
</style>
